import { t as globalT, type Translate } from "@redotech/redo-i18n";
import {
  BLUE_YONDER_PROVIDER,
  type DropoffProviderType,
  HAPPY_RETURNS_PROVIDER,
  RETURN_BEAR_PROVIDER,
  VIRTUAL_PROVIDER,
} from "@redotech/redo-return-dropoff-provider-common/dropoff-provider";
import { COMMON } from "@redotech/redo-team-common/localization/language";
import { assertNever } from "@redotech/util/type";

export interface DropoffProviderCopy {
  title: string;
  subtitle: string;
  privacyPolicyText?: string;
  privacyPolicyLinkText?: string;
  privacyPolicyUrl?: string;
}

/**
 * Stock copy for a dropoff provider, `undefined` when the generic drop-off
 * text applies. A default the portal builder overrides, never an override.
 */
export function getDropoffProviderCopy(
  provider: DropoffProviderType,
  t: Translate = globalT,
): DropoffProviderCopy | undefined {
  switch (provider) {
    case BLUE_YONDER_PROVIDER:
      return {
        title: COMMON.ShipmentMethodName_BLUE_YONDER_TITLE,
        subtitle: COMMON.ShipmentMethodName_BLUE_YONDER_SUBTEXT,
        privacyPolicyText: t(
          "By selecting you are agreeing to our privacy policy.",
        ),
      };
    case VIRTUAL_PROVIDER:
    case RETURN_BEAR_PROVIDER:
      return undefined;
    case HAPPY_RETURNS_PROVIDER:
      return {
        title: t("Drop off at any {{provider}} location", {
          provider: "Happy Returns®",
        }),
        subtitle: t(
          "Take it to one of our nearby locations. No need for packaging or a shipping label.",
        ),
        privacyPolicyText: t(
          "By continuing, you acknowledge that you have had an opportunity to read",
        ),
        privacyPolicyLinkText: t("{{provider}}' Privacy Policy", {
          provider: "Happy Returns",
        }),
        privacyPolicyUrl: "https://happyreturns.com/privacy-policy",
      };
    default:
      assertNever(provider);
  }
}
